import {WhiteCard} from "../_components/WhiteCard";
import React from "react";
import {Badge} from "react-bootstrap";
import {ABOverlayPopover} from "../../_components/CustomOverlayTooltip";
import {useTopicSSE} from "../../../hooks/useTopicSSE";
import {SseTopics} from "../../../context/SSEContext";
import {TableLikeText} from "../../_components";
import {endpoints, formatBytes, formatTime} from "../../../utils2";
import {useGetJson} from "../../../hooks";
import {useParams} from "react-router-dom";
import {useAuth} from "../../../context";

export function AnnouncementSection() {
    return <>
        <WhiteCard className="flex-fill">
            <AnnouncementCard/>
        </WhiteCard>
    </>
}

function AnnouncementCard() {
    const {uid} = useParams()
    const {authToken} = useAuth()
    const online = useTopicSSE(SseTopics.Online)
    const announce = useTopicSSE(SseTopics.Announce)
    const usb = useTopicSSE(SseTopics.USB)
    //  annc (announcement count on board),aanid (uuid announcement running)
    const [annsDet, loadingAnDetails, errorAnDetails, clearErrorAnDetails] = useGetJson(endpoints.announcement.get(uid, announce?.name), authToken?.jwt)
    const announcementDetails = annsDet?.data

    return <div>
        <div className="d-flex align-items-center gap-2 mb-2">
            {usb?.USB ? <ABOverlayPopover buttonLabel={<AnnouncementBadge online={online} usb={usb?.USB}/>} headerText="Additional details">
                    <div>
                        <TableLikeText titleColor="text-light" title="Label" value={usb?.label}/>
                        <TableLikeText titleColor="text-light" title="Free space" value={formatBytes(usb?.free * 1024)}/>
                        <TableLikeText titleColor="text-light" title="Size" value={formatBytes(usb?.size * 1024)}/>
                        <TableLikeText titleColor="text-light" title="Serial" value={usb?.SN}/>
                        <TableLikeText titleColor="text-light" title="File System" value="FAT32"/>
                    </div>
                </ABOverlayPopover>
                :
                <AnnouncementBadge online={online} usb={usb?.USB}/>}
        </div>

        {announce?.state > 0 && <>
            <TableLikeText title="Announcements" value={announce?.cnt}/>
            <TableLikeText title="Pending" value={announce?.idx}/>
        </>}

        {(announce?.state === 2 || announce?.state === 3) && <>
            <div>{announcementDetails?.filename}</div>
            <div>{`${formatTime(announce?.size / 2/ 16000)} - ${(Math.round(((announce?.play * 100) / announce?.size), 0))}%`}</div>
        </>}

        {(announce?.state === 1 || announce?.state === 4) && <TableLikeText title="Next in" value={formatTime(announce?.next)}/>}

    </div>
}

function AnnouncementBadge({online, usb}) {
    return <Badge bg={!online ? "secondary" : usb ? "info" : "warning"}>
        <div className="d-flex align-items-center gap-2">ANNOUNCEMENT <i className="fs-5 bi bi-megaphone"/></div>
    </Badge>
}

export const AnnounceMap = {
    0: "Nothing",
    1: "Waiting",
    2: "Opening",
    3: "Executing",
    4: "Ended",
}
